import Customer           from "../../../domain/customer/Customer";
import CustomerBirthDate  from "../../../domain/customer/CustomerBirthDate";
import CustomerBirthMonth from "../../../domain/customer/CustomerBirthMonth";
import CustomerBirthYear  from "../../../domain/customer/CustomerBirthYear";
import CustomerNumber     from "../../../domain/customer/CustomerNumber";
import Building           from "../../../domain/fundamentals/address/Building";
import City               from "../../../domain/fundamentals/address/City";
import PostalCode         from "../../../domain/fundamentals/address/PostalCode";
import Prefecture         from "../../../domain/fundamentals/address/Prefecture";
import Street             from "../../../domain/fundamentals/address/Street";
import Email              from "../../../domain/fundamentals/email/Email";
import GenderType         from "../../../domain/fundamentals/gender/GenderType";
import FirstName          from "../../../domain/fundamentals/name/FirstName";
import FirstNameKana      from "../../../domain/fundamentals/name/FirstNameKana";
import LastName           from "../../../domain/fundamentals/name/LastName";
import LastNameKana       from "../../../domain/fundamentals/name/LastNameKana";
import Phone              from "../../../domain/fundamentals/phone/Phone";
import ResKaReduxAction   from "../ResKaReduxAction";

export enum ACTION_TYPE {
  SET_CUSTOMER = "SET_CUSTOMER",
  SET_CUSTOMER_DETAIL_NUMBER = "SET_CUSTOMER_DETAIL_NUMBER",
  SET_CUSTOMER_DETAIL_LAST_NAME = "SET_CUSTOMER_DETAIL_LAST_NAME",
  SET_CUSTOMER_DETAIL_LAST_NAME_KANA = "SET_CUSTOMER_DETAIL_LAST_NAME_KANA",
  SET_CUSTOMER_DETAIL_FIRST_NAME = "SET_CUSTOMER_DETAIL_FIRST_NAME",
  SET_CUSTOMER_DETAIL_FIRST_NAME_KANA = "SET_CUSTOMER_DETAIL_FIRST_NAME_KANA",
  SET_CUSTOMER_DETAIL_GENDER_TYPE = "SET_CUSTOMER_DETAIL_GENDER_TYPE",
  SET_CUSTOMER_BIRTHDAY_YEAR = "SET_CUSTOMER_BIRTHDAY_YEAR",
  SET_CUSTOMER_BIRTHDAY_MONTH = "SET_CUSTOMER_BIRTHDAY_MONTH",
  SET_CUSTOMER_BIRTHDAY_DATE = "SET_CUSTOMER_BIRTHDAY_DATE",
  SET_CUSTOMER_CONTACT_PHONE = "SET_CUSTOMER_CONTACT_PHONE",
  SET_CUSTOMER_CONTACT_EMAIL = "SET_CUSTOMER_CONTACT_EMAIL",
  SET_CUSTOMER_ADDRESS_POSTAL_CODE = "SET_CUSTOMER_ADDRESS_POSTAL_CODE",
  SET_CUSTOMER_ADDRESS_PREFECTURE = "SET_CUSTOMER_ADDRESS_PREFECTURE",
  SET_CUSTOMER_ADDRESS_CITY = "SET_CUSTOMER_ADDRESS_CITY",
  SET_CUSTOMER_ADDRESS_STREET = "SET_CUSTOMER_ADDRESS_STREET",
  SET_CUSTOMER_ADDRESS_BUILDING = "SET_CUSTOMER_ADDRESS_BUILDING",
}

export interface SetCustomerAction extends ResKaReduxAction {
  customer: Customer;
}

export interface SetCustomerDetailNumberAction extends ResKaReduxAction {
  customerNumber: CustomerNumber;
}

export interface SetCustomerDetailLastNameAction extends ResKaReduxAction {
  lastName: LastName;
}

export interface SetCustomerDetailFirstNameAction extends ResKaReduxAction {
  firstName: FirstName;
}

export interface SetCustomerDetailLastNameKanaAction extends ResKaReduxAction {
  lastNameKana: LastNameKana;
}

export interface SetCustomerDetailFirstNameKanaAction extends ResKaReduxAction {
  firstNameKana: FirstNameKana;
}

export interface SetCustomerDetailGenderTypeAction extends ResKaReduxAction {
  genderType: GenderType;
}

export interface SetCustomerBirthdayYearAction extends ResKaReduxAction {
  year: CustomerBirthYear;
}

export interface SetCustomerBirthdayMonthAction extends ResKaReduxAction {
  month: CustomerBirthMonth;
}

export interface SetCustomerBirthdayDateAction extends ResKaReduxAction {
  date: CustomerBirthDate;
}

export interface SetCustomerContactPhoneAction extends ResKaReduxAction {
  phone: Phone;
}

export interface SetCustomerContactEmailAction extends ResKaReduxAction {
  email: Email;
}

export interface SetCustomerAddressPostalCodeAction extends ResKaReduxAction {
  postalCode: PostalCode;
}

export interface SetCustomerAddressPrefectureAction extends ResKaReduxAction {
  prefecture: Prefecture;
}

export interface SetCustomerAddressCityAction extends ResKaReduxAction {
  city: City;
}

export interface SetCustomerAddressStreetAction extends ResKaReduxAction {
  street: Street;
}

export interface SetCustomerAddressBuildingAction extends ResKaReduxAction {
  building: Building;
}

export type CustomerAction =
  SetCustomerAction
  | SetCustomerDetailNumberAction
  | SetCustomerDetailLastNameAction
  | SetCustomerDetailLastNameKanaAction
  | SetCustomerDetailFirstNameAction
  | SetCustomerDetailFirstNameKanaAction
  | SetCustomerDetailGenderTypeAction
  | SetCustomerBirthdayYearAction
  | SetCustomerBirthdayMonthAction
  | SetCustomerBirthdayDateAction
  | SetCustomerContactPhoneAction
  | SetCustomerContactEmailAction
  | SetCustomerAddressPostalCodeAction
  | SetCustomerAddressPrefectureAction
  | SetCustomerAddressCityAction
  | SetCustomerAddressStreetAction
  | SetCustomerAddressBuildingAction
  ;

export const setCustomerAction = (customer: Customer): SetCustomerAction => ({
  type: ACTION_TYPE.SET_CUSTOMER,
  customer: customer,
});

export const setCustomerDetailNumberAction = (customerNumber: CustomerNumber): SetCustomerDetailNumberAction => ({
  type: ACTION_TYPE.SET_CUSTOMER_DETAIL_NUMBER,
  customerNumber: customerNumber,
});

export const setCustomerDetailLastNameAction = (lastName: LastName): SetCustomerDetailLastNameAction => ({
  type: ACTION_TYPE.SET_CUSTOMER_DETAIL_LAST_NAME,
  lastName: lastName,
});

export const setCustomerDetailFirstNameAction = (firstName: FirstName): SetCustomerDetailFirstNameAction => ({
  type: ACTION_TYPE.SET_CUSTOMER_DETAIL_FIRST_NAME,
  firstName: firstName,
});

export const setCustomerDetailLastNameKanaAction = (lastNameKana: LastNameKana): SetCustomerDetailLastNameKanaAction => ({
  type: ACTION_TYPE.SET_CUSTOMER_DETAIL_LAST_NAME_KANA,
  lastNameKana: lastNameKana,
});

export const setCustomerDetailFirstNameKanaAction = (firstNameKana: FirstNameKana): SetCustomerDetailFirstNameKanaAction => ({
  type: ACTION_TYPE.SET_CUSTOMER_DETAIL_FIRST_NAME_KANA,
  firstNameKana: firstNameKana,
});

export const setCustomerDetailGenderTypeAction = (genderType: GenderType): SetCustomerDetailGenderTypeAction => ({
  type: ACTION_TYPE.SET_CUSTOMER_DETAIL_GENDER_TYPE,
  genderType: genderType,
});

export const setCustomerDetailBirthdayYearAction = (year: CustomerBirthYear): SetCustomerBirthdayYearAction => ({
  type: ACTION_TYPE.SET_CUSTOMER_BIRTHDAY_YEAR,
  year: year,
});

export const setCustomerDetailBirthdayMonthAction = (month: CustomerBirthMonth): SetCustomerBirthdayMonthAction => ({
  type: ACTION_TYPE.SET_CUSTOMER_BIRTHDAY_MONTH,
  month: month,
});

export const setCustomerDetailBirthdayDateAction = (date: CustomerBirthDate): SetCustomerBirthdayDateAction => ({
  type: ACTION_TYPE.SET_CUSTOMER_BIRTHDAY_DATE,
  date: date,
});

export const setCustomerContactPhoneAction = (phone: Phone): SetCustomerContactPhoneAction => ({
  type: ACTION_TYPE.SET_CUSTOMER_CONTACT_PHONE,
  phone: phone,
});

export const setCustomerContactEmailAction = (email: Email): SetCustomerContactEmailAction => ({
  type: ACTION_TYPE.SET_CUSTOMER_CONTACT_EMAIL,
  email: email,
});

export const setCustomerContactPostalCodeAction = (postalCode: PostalCode): SetCustomerAddressPostalCodeAction => ({
  type: ACTION_TYPE.SET_CUSTOMER_ADDRESS_POSTAL_CODE,
  postalCode: postalCode,
});

export const setCustomerContactPrefectureAction = (prefecture: Prefecture): SetCustomerAddressPrefectureAction => ({
  type: ACTION_TYPE.SET_CUSTOMER_ADDRESS_PREFECTURE,
  prefecture: prefecture,
});

export const setCustomerContactCityAction = (city: City): SetCustomerAddressCityAction => ({
  type: ACTION_TYPE.SET_CUSTOMER_ADDRESS_CITY,
  city: city,
});

export const setCustomerContactStreetAction = (street: Street): SetCustomerAddressStreetAction => ({
  type: ACTION_TYPE.SET_CUSTOMER_ADDRESS_STREET,
  street: street,
});

export const setCustomerContactBuildingAction = (building: Building): SetCustomerAddressBuildingAction => ({
  type: ACTION_TYPE.SET_CUSTOMER_ADDRESS_BUILDING,
  building: building,
});